import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class OfferDetailsRepository extends CrudRepository {
  constructor () {
    super('core/api/offers/details/')
  }

  async getOfferDetails (id) {
    const type = {
      headers: {
        'user-type': 'guest'
      }
    }
    const data = await Repository.get(`${this.resource}${id}/web`, type)
    return data.data
  }
}
